export default {
  'profile.name': 'Profile',
  'accounts.userName': 'User Name',
  'accounts.accountFullName': 'Full name',
  'accounts.email': 'Email',
  'accounts.phoneNumber': 'Phone number',
  'profile.code.title': 'Unable to Log In',
  'profile.code.content': 'Please contact the system administrator.',
};
